import React, {useState, useRef} from 'react'
import PropTypes from 'prop-types'
import {Box, useBreakpointValue} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'
import YoutubeIframe from '../../youtube-video'
import {getDamImageUrl} from '../../../utils/contentstack-utils'
import PlayIcon from '../../icons/action/PlayIcon'

export const EditorialVideo = ({data}) => {
    const [isPlaying, setIsPlaying] = useState(false)
    const videoRef = useRef(null)

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play()
                setIsPlaying(true)
            } else {
                videoRef.current.pause()
                setIsPlaying(false)
            }
        }
    }

    const handleVideoEnd = () => {
        setIsPlaying(false)
    }

    const videoSrc = useBreakpointValue({
        base: data?.akamai_videos?.mobile || data?.akamai_videos?.desktop,
        sm: data?.akamai_videos?.desktop,
    })
    const videoThumbnail = useBreakpointValue({
        base: getDamImageUrl(data?.mobile_fallback_thumbnaill),
        sm: getDamImageUrl(data?.desktop_fallback_thumbnail),
    })

    if (data?.type_of_video === 'Akamai reference') {
        return (
            <Box
                style={{
                    width: '100%',
                    maxWidth: remCalc(1920),
                    position: 'relative',
                }}
                paddingY={{base: remCalc(16), md: remCalc(24), lg: remCalc(40)}}
            >
                <video
                    ref={videoRef}
                    onEnded={handleVideoEnd}
                    onPlay={() => setIsPlaying(true)}
                    onPause={() => setIsPlaying(false)}
                    muted
                    width={'100%'}
                    height={'100%'}
                >
                    <source src={videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <Box
                    as="button"
                    onClick={handlePlayPause}
                    style={{
                        position: 'absolute',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        cursor: 'pointer',
                        top: 0,
                        left: 0,
                    }}
                >
                    {!isPlaying && (
                        <PlayIcon
                            height={remCalc(40)}
                            width={remCalc(40)}
                            fill="background.default"
                            data-testid="play-icon"
                        />
                    )}
                </Box>
            </Box>
        )
    }

    if (data?.type_of_video === 'Youtube link') {
        return (
            <Box
                style={{
                    width: '100%',
                    aspectRatio: '16 / 9',
                    maxWidth: remCalc(1920),
                }}
                data-testid="youtube-video"
            >
                <YoutubeIframe
                    title={data?.title}
                    videoSrc={data?.youtube_link}
                    thumbnail={videoThumbnail}
                />
            </Box>
        )
    }
}

EditorialVideo.propTypes = {
    data: PropTypes.object,
}
